import './style.scss';
import './wix.scss';

import Button from './button.js';

export default Button;